// Batch 8.4 · A3 (F-54) — one way to name an engagement on screen. An engagement saved without a client name (live:
// 1c6e75a6…, FY2026) reads "(no client name)" everywhere instead of a blank; new and edited engagements are refused without one.
export function clientName(e, t) {
  const name = String((e && e.client_name) || "").trim();
  if (name) return name;
  try {
    const s = typeof t === "function" ? t("engagements.noClientName") : "";
    if (s && s !== "engagements.noClientName") return s;
  } catch { /* fall through */ }
  return "(no client name)";
}

// Batch 14 · M13 (F-112): the ENGAGEMENT NAME (editable at any stage by any role) is shown first; blank = the client's
// legal name. The client name itself stays what prints in the auditor's report and the FS.
// Batch 16 · Q11 (F-135): with no engagement name the fallback is "client name · firm ref · FY" (as the Recycle Bin
// labels it), so two files of one client can still be told apart; a ref equal to the name is shown once.
export function engagementName(e, t) {
  const n = String((e && e.engagement_name) || "").trim();
  if (n) return n;
  const parts = [clientName(e, t)];
  const ref = String((e && e.firm_engagement_ref) || "").trim();
  if (ref && ref !== parts[0]) parts.push(ref);
  if (e && e.financial_year) parts.push(`FY${e.financial_year}`);
  return parts.join(" · ");
}

/** "2. Qamar BMT · FY2025"; with no engagement name the fallback already carries the FY. */
export function engagementLabel(e, t) {
  const n = String((e && e.engagement_name) || "").trim();
  if (!n) return engagementName(e, t);
  const fy = e && e.financial_year ? ` · FY${e.financial_year}` : "";
  return `${n}${fy}`;
}

/** The firm reference to show NEXT TO the name — blank when it equals the name or is already part of the fallback label. */
export function refBeside(e) {
  const n = String((e && e.engagement_name) || "").trim();
  const ref = String((e && e.firm_engagement_ref) || "").trim();
  if (!n || !ref || ref === n) return "";
  return ref;
}

// Batch 14 · M14 (F-113): the status reminder shown wherever the engagement is named — "Locked" once the engagement is
// signed off / assembly complete, "Report Final dd-MMM-yyyy" once the auditor's report is Final (both can show).
export function lockLabels(e, t, fmtDate) {
  const out = [];
  if (e && (e.signed_off || e.assembly_complete)) out.push(t("engagements.lockedLabel"));
  if (e && e.report_final_at) out.push(`${t("engagements.reportFinalLabel")} ${fmtDate ? fmtDate(e.report_final_at) : String(e.report_final_at).slice(0, 10)}`);
  return out;
}

/* Batch 15 · N6 (F-120): ONE status badge under the engagement name in the sidebar header — Report Final dd-MMM-yyyy first,
   else Locked, else Restored (a package restore), else none. */
export function statusBadge(e, t, fmtDate) {
  if (!e) return null;
  const locks = lockLabels(e, t, fmtDate);
  const final = locks.find((l) => l.startsWith(t("engagements.reportFinalLabel")));
  if (final) return { lock: true, text: final };
  if (locks.length) return { lock: true, text: locks[0] };
  if (e.restored_from_package || e.package_restore_missing) return { lock: false, text: t("pkg.restoredBadge") };
  return null;
}

export default { clientName, engagementName, engagementLabel, refBeside, lockLabels, statusBadge };
